var map = {
	"./Bumblebee.jpg": "1ab1",
	"./Bumblebee.png": "b706",
	"./Cat.jpg": "1262",
	"./Cat.png": "475b",
	"./Chinchilla.jpg": "99e5",
	"./Chinchilla.png": "8268",
	"./Degu.jpg": "35e8",
	"./Degu.png": "f3fe",
	"./Dog.jpg": "4451",
	"./Dog.png": "8f59",
	"./Hummingbird.jpg": "7dd4",
	"./Hummingbird.png": "eb53",
	"./Koala.jpg": "98ee",
	"./Koala.png": "8578",
	"./ProfilePicture.png": "867f",
	"./Puffer.jpg": "4fb4",
	"./Puffer.png": "e07a",
	"./RedPanda.jpg": "9d03",
	"./RedPanda.png": "d829",
	"./Sheep.jpg": "828d",
	"./Sheep.png": "5eac",
	"./Squirrel.jpg": "5066",
	"./Squirrel.png": "4e75",
	"./Unicorn.png": "9c35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac8b";